import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFacebookF,
  faTwitter,
  faLinkedin,
  faInstagram,
  faYoutube
} from "@fortawesome/free-brands-svg-icons";
import "./footer.scss";
import { useLocation } from "react-router-dom";

const footerBg = {
  backgroundImage:
    "url('./images/itnoa-footer.webp'), url('./images/itnoa-footer.jpg')",
};
const footerLogo = process.env.PUBLIC_URL + "/images/itnoa-light.png";

function Footer() {
  const location = useLocation();
  return (
    <div className="footer-section" style={footerBg}>
      <Container>
        <Row>
          <Col xs={12}>
            <div className="footer-top">
              <div className="footer-logo">
                <img src={footerLogo} alt="footer-logo" />
              </div>
              <p className="footer-desc">
                Please reach for your queries & suggestions through our most
                <br /> active social media channels{" "}
              </p>

              <ul className="footer-social">
                <li>
                  <a href="https://www.facebook.com/profile.php?id=61558420967374" target="_blank">
                    <FontAwesomeIcon icon={faFacebookF} />
                  </a>
                </li>
                <li>
                  <a href="/" target="_blank">
                    <FontAwesomeIcon icon={faTwitter} />
                  </a>
                </li>
                <li>
                  <a href="https://www.youtube.com/@ITNOADEVS" target="_blank">
                    <FontAwesomeIcon icon={faYoutube} />
                  </a>
                </li>
                <li>
                  <a href="https://www.linkedin.com/company/itnoa-devs/mycompany" target="_blank">
                    <FontAwesomeIcon icon={faLinkedin} />
                  </a>
                </li>
                <li>
                  <a href="/" target="_blank">
                    <FontAwesomeIcon icon={faInstagram} />
                  </a>
                </li>
              </ul>
            </div>

            <div className="footer-bottom">
              <Row>
                <Col xs={12} lg={4}>
                  <p>Copyright © {new Date().getFullYear()} | All Right Reserved by ITNOA Devs</p>
                </Col>
                <Col xs={12} lg={8}>
                  <ul className="footer-pages">
                    <li className="disp-xs-none">
                      <a
                        href={`${
                          location.pathname === "/" ? "#home" : "/#home"
                        }`}
                      >
                        Home
                      </a>
                    </li>
                    <li>
                      <a
                        href={`${
                          location.pathname === "/" ? "#about" : "/#about"
                        }`}
                      >
                        About
                      </a>
                    </li>
                    <li className="disp-xs-none">
                      <a
                        href={`${
                          location.pathname === "/" ? "#contact" : "/#contact"
                        }`}
                      >
                        Contact Us
                      </a>
                    </li>
                    <li>
                      <a href="/privacy-policy">Privacy Policy</a>
                    </li>
                    <li>
                      <a href="/terms">Terms & Conditions</a>
                    </li>
                  </ul>
                </Col>
              </Row>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Footer;
